import './libs/modernizr.js';
import './libs/bootstrap';


// JS class helper
var body = document.querySelector('body');
body.classList.add('js');

// To top body class helper
window.onscroll = function(e) {
    if (window.pageYOffset > 500) {
        body.classList.add('show-to-top');
    } else {
        body.classList.remove('show-to-top');
    }
};

// Touch body class helper
if ('ontouchstart' in window || navigator.maxTouchPoints) {
    body.classList.add('touch');
}

require('./modules/headroom')
require('./modules/lazy-load')
require('./modules/slider')
require('./modules/map')
require('./modules/ajax-form-handler')
require('./modules/aos')
// require('./modules/ajax-posts')
require('./modules/testimonial')
require('./modules/mobile')


jQuery(document).ready(function($) {

console.log("FRDBG");

    $('#supply-areas').click(function(){
            $('#tariff_calculator_form').toggleClass('visible');
            $('#supply-areas-map').toggle();
            $('#tarifbtntxt').toggle();
            $('#supplybtntxt').toggle();
        });

    $('#wasser-areas').click(function(){
            $('#tariff_calculator_form').toggleClass('visible');
            $('#supply-areas-map').toggle();
            $('#tarifbtntxt').toggle();
            $('#wasserbtntxt').toggle();
        });

    $("#select-tarif").click(function(){
            // $('#tarif-result').toggle();
            getTariff();
        });


    $(".personinhouse").click(function(){
        
        var pb = [];
        pb[1] = "0";
        pb[2] = "40%";
        pb[3] = "70%";
        pb[4] = "100%";


        var pa = [];
        pa[1] = "0";
        pa[2] = "30%";
        pa[3] = "60%";
        pa[4] = "90%";

        var personnum = this.dataset.val;
        var data_val = this.dataset.value;
        $('.personinhouse').removeClass('selected');
        for (let index = 1; index <= personnum; index++) {
            $(".progress"+index).addClass('selected');   
        }

        $(".profileprogress_baractive").css("width",pb[personnum]);
        $(".profileprogress_active").css("left",pa[personnum]);

        $("#personinhouse_value").val(data_val);
    });

});


function getTariff(url) {

console.log(document.getElementById("tarif-result").style.display);
//console.log(document.getElementById("tarif-result").style);

	if (document.getElementById("tarif-result").style.display != 'block') {


		var data = {
			action: "tariff_call",
			my_input: "some_value tariff"
		};


		jQuery.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: "action=" + data.action + "&my_input=" + data.my_input,
			success: function(response) {
				console.log('Response:', response);
				const jsonObject = JSON.parse(response);
				console.log('Object value:', jsonObject.systemOperator);

				jQuery('#tarif-result').toggle();
			}
		});


	} else

	        jQuery('#tarif-result').toggle();

}

